import { EventBody } from '../../gds-api-client';
import { DeleteConfirmation as DeleteScreen, RouterContext } from '../../gs-component-right-rail';
import React, { useContext } from 'react';

import { OnSuccess } from '../LegacyModal/RightRailForm';
import { ApiClientsContext } from './ApiClientsContext';
import { TrackingContext } from './TrackingContext';

interface Props {
  onSuccess: OnSuccess;
  setClose: (value: boolean) => void;
}

export const DeleteConfirmation: React.FC<Props> = ({ onSuccess, setClose }) => {
  const { push, goBack } = useContext(RouterContext);
  const { gdsApi, gdsEvent } = useContext(ApiClientsContext);
  const { track } = useContext(TrackingContext);

  const deleteEvent = async (): Promise<void> => {
    if (gdsEvent && (gdsEvent as EventBody).id) {
      try {
        const event = gdsEvent as EventBody;
        const id = event.id as string;
        await gdsApi.deleteEvent(id);
        track('Event Deleted', {
          source: 'event modal',
          eventType: 'custom',
          eventName: event.name,
          eventScheduleItems: event.subEvents ? event.subEvents.length : 0,
          eventVisible: event.visible,
          rsvpOn: event.requireRsvp,
        });
        onSuccess({ deleted: true, id });
        push('main');
        setClose(false);
      } catch (error) {
        // TODO: Error handling
      }
    }
  };
  return (
    <DeleteScreen
      onDelete={deleteEvent}
      onCancel={goBack}
      info="Deleting this event will remove it from your website, and also erase any guest lists, RSVPs and meals associated with it."
    />
  );
};
